// extracted by mini-css-extract-plugin
export default {"lDelete":"tags_lDelete__MViRy","dCategories":"tags_dCategories__CrlRh","term":"tags_term__L9UCE"};